import { Currency } from "@paywithglide/glide-js";

interface ProcessCurrenciesOptions {
  excludeCurrencyTiers?: string[];
  allowedPaymentCurrencies?: string[];
  excludedPaymentCurrencies?: string[];
}

export function processCurrencies(
  currencies: Currency[],
  options: ProcessCurrenciesOptions = {},
): Currency[] {
  const {
    excludeCurrencyTiers,
    allowedPaymentCurrencies,
    excludedPaymentCurrencies,
  } = options;

  let filtered = currencies;

  if (excludeCurrencyTiers?.length) {
    filtered = filtered.filter(
      (currency) =>
        !currency.tier || !excludeCurrencyTiers.includes(currency.tier),
    );
  }

  if (allowedPaymentCurrencies?.length) {
    filtered = filtered.filter((currency) =>
      allowedPaymentCurrencies.includes(currency.id),
    );
  }

  if (excludedPaymentCurrencies?.length) {
    const excludedIds = new Set(
      excludedPaymentCurrencies.map((item) => item.toLowerCase()),
    );
    const excludedSymbolsFromIds = new Set(
      filtered
        .filter((currency) => excludedIds.has(currency.id.toLowerCase()))
        .map((currency) => currency.symbol.toLowerCase()),
    );

    filtered = filtered.filter((currency) => {
      const excludeList = excludedPaymentCurrencies;

      if (
        excludeList.some(
          (item) => item.toLowerCase() === currency.id.toLowerCase(),
        )
      ) {
        return false;
      }

      if (
        excludeList.some(
          (item) => item.toLowerCase() === currency.symbol.toLowerCase(),
        )
      ) {
        return false;
      }

      // Backward-compatible expansion: if a specific currency id is excluded,
      // exclude all currencies that share that symbol.
      if (excludedSymbolsFromIds.has(currency.symbol.toLowerCase())) {
        return false;
      }

      if (
        excludeList.some((item) => {
          const isAddress = /^(0x[a-fA-F0-9]{40}|[a-zA-Z0-9]{32,44})$/.test(
            item,
          );
          if (isAddress) {
            return currency.id.toLowerCase().includes(item.toLowerCase());
          }
          return false;
        })
      ) {
        return false;
      }

      return true;
    });
  }

  const seenIds = new Set<string>();
  return filtered.filter((currency) => {
    if (currency.id === "bob") return false;
    if (seenIds.has(currency.id)) return false;
    seenIds.add(currency.id);
    return true;
  });
}
